@if (user) {
    <ls-section-box
        #playerscore="playerscore"
        #vipLevels="vipLevels"
        #userProfile="userProfile"
        class="profile-info"
        lsPlayerscore
        lsVipLevels
        lsUserProfile
    >
        @let profileData = userProfile.userProfileInfo$ | async;

        <button
            class="profile-info__user"
            [title]="'common.user-cabinet' | translate"
            (click)="navigateProfile()"
        >
            <ls-account-avatar class="profile-info__user-avatar"/>

            <span
                class="profile-info__user-name _graphic-sub-md _500"
                [title]="profileData?.nickname ?? user.login"
            >
                {{ profileData?.nickname ?? user.login }}
            </span>

            <ls-ui-icon
                class="profile-info__user-icon"
                height="24"
                src="chevron"
                width="24"
            />
        </button>

        @if (playerscore.score()?.level || playerscore.score()?.level === 0) {
            <hr class="profile-info__hr"/>

            <!-- TODO Fix isArray -->
            <ls-vip-progress-bar
                class="profile-info__progress-bar"
                [isRedirect]="true"
                [levelValue]="playerscore.score()?.level"
                [levels]="Array.isArray(vipLevels.levels()) ? vipLevels.levels() : []"
                [percentValue]="playerscore.score()?.percentage"
                (click)="navigateVip()"
            />
        }
    </ls-section-box>
}
